module.exports = __webpack_public_path__ + "media/swan.f2d7eb16.mp3";